<template>
  <div>
    <v-container style="direction: ltr">
        <v-img
            class="mt-4 mb-4"
            max-height="100"
            max-width="200"
            src="@/assets/esite_logo.png"
            contain
        />
        <div>
          eSITE Information Technology LLC, Is an Iraqi based software
          development company which is specialized by building customized
          software solutions to all kinds of businesses such as small,
          medium and enterprise levels. We are proud to provide the
          highest quality and latest technologies in the field of web
          applications and mobile applications. Don't hesitate to contact
          us on:
          <br />
          <a href="mailto:info@esite-iq.com">info@esite-iq.com</a> or
          +9647901611249
        </div>
    </v-container>
  </div>
</template>

<script>
export default {
name: "Help"
}
</script>

<style scoped>

</style>